<template>
<div @mouseenter="headerSelectmouseenter()" @mouseleave="headerSelectmouseleave()" class="headerSelectClass">
        <div>
            <div class="rightBoxA"></div>
            <div class="rightBox"></div>
            <ul class="accountSelectUl">
            <li
                @mousedown="mousedownFunc('myAccount', '1')"
                @mouseup="mouseupFunc('myAccount', '1')"
            >{{ $t('myConsole') }}
            </li>
            <li
                @mousedown="mousedownFunc('logOut', '1')"
                @mouseup="mouseupFunc('logOut', '1')"
                style="text-align:left;"
            >{{ $t('loginOut') }}</li>
            </ul>
        </div>
</div>
</template>

<script>
// import config from '../../config'
export default {
    data () {
        let protocol = window.location.protocol
        let splitLine = '//'
        let env = window.location.hostname
        let path = protocol + splitLine + env
        return {
            loginOut: '',
            base: path,
            path: '',
            env: env,
            baseUrl: '/developerUser',
            frontPort: '8080'
        }
    },
    methods: {
        headerSelectmouseenter () {
            this.$store.state.isIndexSelectShow = true
        },
        headerSelectmouseleave () {
            this.$store.state.isIndexSelectShow = false
        },
        loginOutFn () {
            localStorage.removeItem('token')
            this.$store.state.token = null
            sessionStorage.removeItem('registeredDetail')
            this.$store.state.registeredDetail = null
            this.$store.state.isSideBarShow = null
            sessionStorage.removeItem('isSideBarShow')
            this.env === 'localhost' ? this.path = this.base + ':' + this.frontPort + this.baseUrl + '/login' : this.path = this.base + this.baseUrl + '/login'
            window.location.href = this.path
            this.$store.state.borderStyle = 'login'
            localStorage.setItem('clickState', 'login')
        },
        mouseupFunc (to, type, url) {
            if (to === 'logOut') {
                // this.$confirm('此操作将登出账户, 是否继续?', '钕娲团队提示', {
                    // confirmButtonText: '确定',
                    // cancelButtonText: '取消',
                    // type: 'warning'
                // }).then(() => {
                this.loginOutFn()
                    // this.$message({
                    //     type: 'success',
                    //     message: '删除成功!'
                    // })
                // }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // })
                    // this.isFlagIconClass = null
                // })
                return
            }
            if (url && type === '0') {
                this.$router.push({ name: 'listApp' })
            } else if (url && type === '1') {
                if (to === 'bbsSty') {
                    window.location.href = url
                } else {
                    this.$router.push({ name: 'listApp' })
                }
            } else {
                if (type === '0') {
                } else {
                    // this.env === 'localhost' ? this.path = this.base + ':' + this.frontPort + this.baseUrl + '/myAccount' : this.path = this.base + this.baseUrl + '/myAccount'
                    this.env === 'localhost' ? this.path = this.base + ':' + this.frontPort + this.baseUrl + '/myprojects/list' : this.path = this.base + this.baseUrl + '/myprojects/list'
                    window.location.href = this.path
                }
            }
            this.$store.state.isFlagSpanClass = null
        },
        mousedownFunc (to, type, url) {
            if (to === 'logOut') {
                return
            }
        },
        consoleFunc () {
            this.$store.state.isIndexSelectShow = false
            this.$store.state.borderStyle = 'file'
            localStorage.setItem('clickState', 'file')
            this.$router.push({name: 'listApp'})
        }
    },
    computed: {
        registeredDetail () {
            if (sessionStorage.registeredDetail === 'true' && localStorage.token !== undefined) {
                this.loginOut = this.$t('loginOut')
            } else {
                this.loginOut = this.$t('login')
            }
            return this.$store.state.registeredDetail
        }
    }
}
</script>
<style scoped>
/* 新增 */
*{
    margin: 0px;
    padding: 0px;
    list-style: none;
    font-size: 0px;
}
.rightBox {
    width: 0;
    height: 0;
    border-width: 0 5px 5px;
    border-style: solid;
    border-color: transparent transparent #fff;
    margin: 0px auto;
    top: 1px;
    position: relative;
    z-index: 1;
}
.rightBoxA {
    width: 0;
    height: 0;
    border-width: 0 6px 6px;
    border-style: solid;
    border-color: transparent transparent rgba(51, 51, 51, 0.2);
    margin: 0px auto;
    position: relative;
    top: 5.8px;
    left: -0.2px;
}
.accountSelectUl {
    padding-top: 6px;
    padding-bottom: 4px;
    border: solid 1px rgba(51, 51, 51, 0.2);
    border-radius: 5px;
    background-color: #ffffff;
}
.accountSelectUl li {
    /* width: 51px; */
    height: 28px;
    text-align: center;
    /* height: 28px; */
    font-family: sans-serif;
    font-size: 12px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: 28px;
    letter-spacing: 0.7px;
    color: #333333;
    padding: 0px 10px;
}
.accountSelectUl li:hover {
    background-color: rgba(0, 224, 218, 0.1);
    cursor: pointer;
}
.accountSelectUl li:active {
    color: #00b5e2 !important;
    font-weight: 500 !important;
    box-sizing: border-box;
}
.accountSelect {
    position: absolute;
    top: 55px;
    left: -23px;
    z-index: 3;
}
/* 新增 */
.headerSelectHover:hover{
    /* background-color: rgba(0, 181, 226, 0.3); */
    cursor: pointer;
    padding-bottom: 2px;
    font-weight: 500!important;
    color: rgba(51, 51, 51, 0.5);
 }
.headerSelectClass{
    /* width: 70px; */
    /* height: 130px; */
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    /* background-color: rgba(255, 255, 255, 0.8); */
    /* border: 1px solid; */
    position: absolute;
    /* right: 279px; */
    /* right: 265px; */
    /* right: 231px; */
    /* right: 23.9%;
    top: 62px; */
    right: 69px;
    /* right: 162px; */
    top: -8px;
    z-index: 2;
    /* padding-bottom: 5px; */
}

.account {
  display: inline-block;
  width: 100%;
  /* width: 113px; */
  height: 28px;
  opacity: 0.8;
  font-family: sans-serif;
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 28px;
  letter-spacing: 1.1px;
  text-align: left;
  color: var(--black);
  padding: 0px 11px;
  /* line-height: 64px; */
  /* padding-top: 17px; */
  /* padding-top: 17px; */
  /* padding-bottom: 32px; */
  /* margin-left: 25px; */
}
.line{
  display: block;
  /* width: 99px; */
  height: 1.2px;
  border: solid .8px #979797;
  margin: auto;
  /* margin-top: 16px;  */
  /* margin-bottom: 16px;  */
  display: none;
}
.account_copy {
  display: block;
  /* width: 113px; */
  height: 28px;
  opacity: 0.8;
  font-family: sans-serif;
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 28px;
  letter-spacing: 1.1px;
  text-align: left;
  color: var(--black);
  padding: 0px 11px;
  /* line-height: 64px; */
  /* padding-top: 17px; */
  /* margin: auto; */
  /* padding-top: 32px; */
  /* margin-left: 25px; */
}
</style>




// WEBPACK FOOTER //
// IndexSelect.vue?7ebc0fae